module.exports = __webpack_public_path__ + "img/logo1.012c7d3f.png";